/* Component Dependencies */
var headerTextCtaTemplate = require('templates/headerTextCta.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'headerTextCta',
  template: {
    'headerTextCta': headerTextCtaTemplate
  }
});
